import { format, toDate, parseISO, formatDistanceToNowStrict } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";

export const Format = (date, mask = "dd/MM/yyyy - hh:mm:ss") =>
  format(new Date(date), mask, { locale: ptBR });

export const dateFormatUS = date =>
  format(new Date(date), "yyyy-MM-dd", { locale: ptBR });

export const dateFormat = Format;

// "yyyy-MM-dd" → [Date, Date] em horário local, para o DatePickerRange.
// parseISO em vez de new Date(): new Date("2026-09-01") é UTC e, no Brasil,
// cai em 31/08. Volta com dateFormatUS.
export const isoDatesToRange = (start, end) => [
  start ? parseISO(start) : null,
  end ? parseISO(end) : null,
];

export const lastDayOfMonth = dirtyDate => {
  const date = toDate(dirtyDate);
  const month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(0, 0, 0, 0);
  return date;
};

// FIXME: Remover nao e o lugar dele (verificar aonde esta utilizando e migrar para o correto)
export const formatCNPJCPF = param => {
  if (!param) return "-";

  const CPF_LENGTH = 11;
  if (!param) return 0;
  const cnpjCpf = param && param.replace(/\D/g, "");

  if (cnpjCpf.length === CPF_LENGTH) {
    return cnpjCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
  }

  return cnpjCpf.replace(
    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g,
    "$1.$2.$3/$4-$5",
  );
};

export const dateFormatInvoice = (data = null, location = "br") => {
  const date = data === null ? new Date() : new Date(data);

  let day = date.getDate();
  let month = date.getMonth() + 1;
  const year = date.getFullYear();

  if (month < 10) month = `0${month}`;
  if (day < 10) day = `0${day}`;

  const today =
    location === "br" ? `${day}/${month}/${year}` : `${year}-${month}-${day}`;
  return today;
};

export const hourFormat = (data = null) => {
  if (!data) return "---";

  let timing = data.split("T")[1].split("-")[0];
  timing = timing.replace(".000Z", "");

  return `${timing}`;
};

export const formatDate = dateString => {
  if (!dateString) {
    return "-";
  }
  const options = { year: "numeric", month: "2-digit", day: "2-digit" };
  return new Date(dateString).toLocaleDateString("pt-BR", options);
};

const formatDistanceLocale = {
  lessThanXSeconds: "{{count}}s",
  xSeconds: "{{count}}s",
  halfAMinute: "30s",
  lessThanXMinutes: "{{count}}m",
  xMinutes: "{{count}}m",
  aboutXHours: "{{count}}h",
  xHours: "{{count}}h",
  xDays: "{{count}}d",
  aboutXWeeks: "{{count}}w",
  xWeeks: "{{count}}w",
  aboutXMonths: "{{count}}m",
  xMonths: "{{count}}m",
  aboutXYears: "{{count}}a",
  xYears: "{{count}}a",
  overXYears: "{{count}}a",
  almostXYears: "{{count}}a",
};

const formatDistanceok = (token, count, options) => {
  options = options || {};

  const result = formatDistanceLocale[token].replace("{{count}}", count);

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return `in ${result}`;
    } else {
      return `Atualizado há ${result}`;
    }
  }

  return result;
};

export const formatDistance = date =>
  formatDistanceToNowStrict(date, {
    addSuffix: true,
    locale: {
      ...ptBR,
      formatDistance: formatDistanceok,
    },
  });

export const concatTime = data => {
  const [hora, minuto] = data?.split(":")?.map(Number) || ["--", "--"];

  const formattedHour = hora?.toString()?.padStart(2, "0");
  const formattedMinute = minuto?.toString()?.padStart(2, "0");

  return `${formattedHour}:${formattedMinute}`;
};

export const checkFormatedDateArrayUS = array => {
  const regex = /^\d{4}-\d{2}-\d{2}$/;
  return array.every(item => regex.test(item));
};

export const transformUsaDateToBr = (date, mask = "dd/MM/yyyy") => {
  if (!date) {
    return;
  }
  const fixedDate = new Date(`${date}T12:00:00`);
  return format(fixedDate, mask, { locale: ptBR });
};

export const dateToIso8601 = date => {
  if (!date) {
    return;
  }
  const [day, month, year] = date.split("/");
  return `${year}-${month}-${day}`;
};

export const dateIsoToDateOnly = isoString => {
  if (!isoString) {
    return;
  }
  if (isoString instanceof Date) {
    return isoString?.toISOString()?.slice(0, 10);
  }
  return isoString?.slice(0, 10);
};

export const formatDateBRWithHours = dateStr => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  const day = date.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  const time = date.toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
  });
  return `${day} às ${time}`;
};
